export { default } from './VerticalTabsIconItem';
export * from './VerticalTabsIconItem.types';
